var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('member-header',{attrs:{"organization-details-route":"me-organization"}}),_c('member-index',{attrs:{"edit-mode":_vm.editMode,"member-view-route":"me-organization-member-view","member-edit-route":"me-organization-member-edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }